import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/Subject'
import { Component } from '@angular/core';
import { $BroadcastManagerService } from '../../BroadcastManager.service';
import { petmbindingData } from '../ModalData';
import { FormGroup } from "@angular/forms";
import { FormBuilder, Validators } from "@angular/forms";
import { APIEntityService } from 'src/app/_root/Trai_module/_services/entity/API-entity';

@Component({
  selector: 'app-petmbinding-dialog',
  templateUrl: './petmbinding-dialog.component.html', 
})

export class PETMBindingDialogComponent {
  public onClose: Subject<boolean>;
    public modalDataObj: petmbindingData;

    errorMessage: any;
    invalidTm: boolean = false;
    promtForm: FormGroup;
    showentity:boolean= false;
    entitygt3:boolean= false;

    get f() {
        return this.promtForm.controls;
      }

    public ngOnInit(): void {
        this.promtForm = this.fb.group({

            remarks: ['',[Validators.required,  Validators.minLength(10)]],
            nextentityid: [''],
            justification:[''],
            tmName:['']
        });
        this.onClose = new Subject();
        console.log("-----sthis.modalDataObj)------",this.modalDataObj)

    }
    constructor(
        public bsModalRef: BsModalRef,
        private $: $BroadcastManagerService,
        private fb: FormBuilder,
        private es: APIEntityService
    ) { }

    public onConfirm(): void {
        console.log("-----selectOption--in petmdialog.ts----",this.modalDataObj)
        //if((this.modalDataObj && this.modalDataObj.remarks)  || (this.modalDataObj.showRadioButton)) {
            // this.promtForm.controls['remarks'].setValidators([Validators.required,  Validators.minLength(10)]);
            // this.promtForm.controls['remarks'].updateValueAndValidity();
        //}
        // if((this.modalDataObj && this.modalDataObj.nextentityid)  || (this.modalDataObj.showRadioButton)) {
            // this.promtForm.controls['nextentityid'].enable();
            // this.promtForm.controls['nextentityid'].setValidators([Validators.required,  Validators.minLength(19)]);
            // this.promtForm.controls['nextentityid'].updateValueAndValidity();
    //    }
        
        console.log("this.promtForm----------",this.promtForm)
        
        if(this.promtForm.valid && !this.invalidTm) {
            console.log("Clicked Ok")
            this.onClose.next(true);
            this.bsModalRef.hide();
        }
    }
    public onCancel(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
        console.log("Clicked Cancel")
    }


    onChangeradiobtn(radiooption){
        console.log("_-------on change-----onChangeradiobtn-------------",radiooption,this.showentity)
   
        if(radiooption=="Telemarketer/Aggregator"){
            console.log("_-----=Telemarketer/Aggregator--------")
            this.showentity = true            
            this.entitygt3 = false
            this.promtForm.controls['nextentityid'].enable();
            this.promtForm.controls['nextentityid'].setValidators([Validators.required,Validators.maxLength(19)]);
            this.promtForm.controls['nextentityid'].updateValueAndValidity();
            if(this.modalDataObj.showjustification == true){
                this.entitygt3 = true
                this.promtForm.controls['justification'].enable();
            this.promtForm.controls['justification'].setValidators([Validators.required,  Validators.minLength(10),Validators.maxLength(100)]);
            this.promtForm.controls['justification'].updateValueAndValidity();
            }
            
        }
        else{
            this.showentity = false
            this.entitygt3 = false
            this.invalidTm = false
            this.errorMessage = ""
            this.promtForm.controls['nextentityid'].clearValidators();           
            this.promtForm.controls['nextentityid'].updateValueAndValidity();
            this.promtForm.controls['justification'].clearValidators();           
            this.promtForm.controls['justification'].updateValueAndValidity();
            console.log("_-----=TMD--------")
        }
    }

    entityname(filterValue: string) {
        let data = {
            TMID: filterValue,
        };
    
        console.log("--------data---", data);
        this.es.gettmname(data).subscribe((r) => {
         // console.log("-----------r----", r);
          if (r.status == "success") {
            this.invalidTm = false;
            this.promtForm.controls['tmName'].setValue(r.message);
          } else {
            this.invalidTm = true;
            this.errorMessage = r.message;
          }
        });
      }
    
    // emitEv(name: string): void {
    //     this.$.emit({
    //         click: name
    //     });
    //     this.bsModalRef.hide();
    // }
}
